import React from 'react';
import PortfolioMain from './components/PortfolioMain';

function App() {
  return (
    <div className="App">
      <PortfolioMain />
    </div>
  );
}

export default App;
